package com.example.mystybag.sharedmodels.project.requestModels.reservations

import com.example.mystybag.sharedmodels.AllCommands.UPDATE_RESERVATION
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
class UpdateReservationStatusRequestModel(
    val reservationId: Long = 0L,
    val status: Int = 0 // 0=RESERVED, 1=PAID, 3=DELIVERED_TO_CLIENT, 4=PAID_TO_MERCHANT
) : BaseRequestModel(api = UPDATE_RESERVATION)